import styled from 'styled-components';
import { SIZE, FONTS } from '@app/src/ui';

interface Props {
  isBold?: boolean;
  color?: string;
}

export const Box = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
`;

Box.displayName = 'Box';

export const PaymentSummary = styled.div`
  font-family: ${FONTS.OPEN_SANS};
  padding: 4px 6px;
  background-color: ${(props: Props) => props.color};
  border-radius: 4px;
  width: 100%;
  font-size: 12px;

  @media(min-width: ${SIZE.TABLET_BREAK}) {
    width: calc(100% - 240px);
  }

  @media(min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 14px;
  }
`;

PaymentSummary.displayName = 'PaymentSummary';

export const SummaryDescription = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
  margin: 4px 0;
`;

SummaryDescription.displayName = 'SummaryDescription';

export const TextDescription = styled.div`
  font-weight: ${(props: Props) =>
    props.isBold && 'bold'};
`;

TextDescription.displayName = 'TextDescription';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

Wrapper.displayName = 'Wrapper';

export const SectionTitle = styled.h3`
  font-family: ${FONTS.ARTISTOTELICA_EXTRALIGHT};
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 1px;
  padding: 8px 6px 4px;
  background-color: ${(props: Props) => props.color};

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 18px;
    max-width: 516px;
  }
`;

SectionTitle.displayName = 'SectionTitle';

export const OperationType = styled.span`
  font-size: 13px;
  text-transform: lowercase;
`;

OperationType.displayName = 'OperationType';
